import React from 'react';
import { Link } from 'react-router-dom';
import { navigationItems } from '../utils/data';

const Footer: React.FC = () => {
  const ParallaxLogo = () => (
    <div className="flex items-center">
      <img 
        src="/images/Parallax-cinema-logo.png" 
        alt="Parallax Cinema" 
        className="h-10 w-auto object-contain"
      />
    </div>
  );

  return (
    <footer className="bg-primary border-t border-secondary/20 mt-20">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <ParallaxLogo />
            </Link>
            <p className="text-secondary mb-6 max-w-md leading-relaxed">
              Where engineering meets artistry. Discover the ultimate fusion of optical precision 
              and acoustic excellence. Parallax Cinema transforms spaces into cinematic sanctuaries.
            </p>
            <div className="space-y-2 text-sm text-secondary">
              <p>By appointment only - experience the extraordinary</p>
              <p>Professional consultation and installation services</p>
            </div>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-accent font-semibold mb-6">Navigation</h3>
            <ul className="space-y-3">
              {navigationItems.map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.href} 
                    className="text-secondary hover:text-highlight transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                  {item.dropdown && (
                    <ul className="ml-4 mt-2 space-y-2">
                      {item.dropdown.map((dropdownItem) => (
                        <li key={dropdownItem.name}>
                          <Link 
                            to={dropdownItem.href}
                            className="text-secondary/80 hover:text-highlight transition-colors text-sm"
                          >
                            {dropdownItem.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-accent font-semibold mb-6">Contact</h3>
            <div className="space-y-4 text-sm text-secondary">
              <div>
                <p className="font-medium text-accent mb-1">Showroom</p>
                <p>205 Diamond Boulevard, Unit 339</p>
                <p>Anchorage, AK 99575</p>
              </div>
              <div>
                <p className="font-medium text-accent mb-1">Consultation</p>
                <p>+1 (555) 123-4567</p>
                <p>consultation@parallaxcinema.com</p>
              </div>
              <div>
                <p className="font-medium text-accent mb-1">Hours</p>
                <p>Monday - Friday: 10AM - 6PM</p>
                <p>Saturday: 10AM - 4PM</p>
                <p>Sunday: By appointment</p>
              </div>
            </div>
          </div>
        </div>

        {/* Awards & Certifications */}
        <div className="border-t border-secondary/20 mt-12 pt-8">
          <div className="mb-6">
            <h3 className="text-accent font-semibold mb-4">Awards & Recognition</h3>
            <div className="flex flex-wrap gap-6 text-sm text-secondary">
              <span>2026 Innovation Award - Home Theater Excellence</span>
              <span>Editor's Choice - AV Magazine</span>
              <span>Best Surround System 2026</span>
              <span>Design Excellence Award</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-secondary/20 pt-8 flex flex-col lg:flex-row justify-between items-center">
          <div className="text-sm text-secondary mb-4 lg:mb-0">
            <p>&copy; 2026 Parallax Cinema. All rights reserved.</p>
          </div>
          <div className="flex items-center space-x-6 text-sm text-secondary">
            <Link to="/privacy" className="hover:text-highlight transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-highlight transition-colors">
              Terms of Service
            </Link>
            <Link to="/warranty" className="hover:text-highlight transition-colors">
              Warranty Information
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 